var POSTS_ARRAY = [];
var CALENDAR_CELL = [];
var POST_IMAGES = [];
var CURRENT_CPT = '';

var HOST = window.location.protocol + "//" + window.location.hostname;
var REST_API = "/wp-json/wp/v2";

var REST_API_LINK = HOST + REST_API;

var postsRequest;
var currentDate = null;
var specialEvent = false;

var CALENDAR_DEBUG = false;

function Calendar(params) {
//	this.image = params.image;
	this.imageId = params.imageId;
	this.title = params.title;
	this.date = params.date;
    this.dates = params.dates;
    this.heure = '';
	this.description = params.description;
	this.link = params.link;
	this.dateDay = null;
	this.special = params.special;
	this.file = params.file;
}

Calendar.prototype.init = function(date) {
	POSTS_ARRAY = [];
	CALENDAR_CELL = [];
	POST_IMAGES = [];
	Calendar.prototype.api(date);
};

Calendar.prototype.api = function(date) {
	if (CALENDAR_DEBUG) {
		console.log('CURRENT_CPT: ', CURRENT_CPT);
	}

	postsRequest = new XMLHttpRequest();
	postsRequest.addEventListener("load", postsRequest_listener);
	postsRequest.addEventListener("error", postsRequest_listener_error);
	postsRequest.open("GET", REST_API_LINK + "/"+CURRENT_CPT+"?lang=" + getTheCurrentLang());
	postsRequest.send();

	currentDate = date;
};

Calendar.prototype.update = function(date) {
	Calendar.prototype.build();
}

Calendar.prototype.imageFetch = function(post) {
	var media;
	var mediaID;
	var mediaLink;

	function makeRequest(method, url) {
		return new Promise(function(resolve, reject) {
			var xhr = new XMLHttpRequest();
			xhr.open(method, url);
			xhr.onload = function() {
				media = JSON.parse(this.responseText);
				mediaID = media.id;
				if(media.media_details && media.media_details.sizes["event-card"])
					mediaLink = media.media_details.sizes["event-card"].source_url;
				else
					mediaLink = '#';

				var obj = {
					mediaID: mediaID,
					mediaLink: mediaLink
				};

				resolve(obj);
			};
			xhr.send();
		});
	}

	var request = makeRequest(
		"GET",
		REST_API_LINK + "/media" + "/" + post.imageId
	).catch(function(err) {
		console.error("Error fetching images!", err.statusText);
	});

	return request;
};

Calendar.prototype.getImageByID = function(id) {
	var newId = parseInt(id);
	for (var v = 0; v < POST_IMAGES.length; v++) {
		if (POST_IMAGES[v].mediaID === newId) {
			return POST_IMAGES[v].mediaLink;
		}
	}
};

Calendar.prototype.build = function() {
	var theCalendar = document.querySelector("#calendar");
	CALENDAR_CELL = [];
	if (theCalendar) {
		var rows = theCalendar.querySelectorAll("tbody tr");

		var first = new Promise(function(resolve, reject) {

			for (var i = 0; i < rows.length; i++) {
				var row = rows[i];
				var cols = row.querySelectorAll("td");

				for (var j = 0; j < cols.length; j++) {
					var cell = cols[j];
					if (!cell.classList.contains("jsCalendar-previous")) {
						if (!cell.classList.contains("jsCalendar-next")) {
							CALENDAR_CELL.push(cell);
						}
					}
				}
			}

			resolve();
		});


		var second = new Promise(function(resolve, reject) {
			var currentMonth = document.querySelector(".jsCalendar-title-name").innerText.split(' ');
			currentMonth = currentMonth[0].toLowerCase();

            var posts = [];
			for (var i = 0; i < POSTS_ARRAY.length; i++) {
				var post = POSTS_ARRAY[i];

				if (CALENDAR_DEBUG) {
					console.log(post);
				}

				if(post.special){
                    for (var j = 0; j < post.dates.length; j++) {
                    	var the_post = new Calendar(post);
                        the_post.dates = [];

                        the_post.date = post.dates[j].date;
                        the_post.heure = post.dates[j].heure;

                        if (CALENDAR_DEBUG) {
                        	console.log(dateDay,dateMonth,dateYear);
                        }
                        posts.push(the_post);
                    }
				}
				else{
                    posts.push(post);
				}
			}

            for (var i = 0; i < posts.length; i++) {
                post = posts[i];

                var date = post.date.split("-");
                var dateDay = parseInt(date[0]);
                var dateMonth = parseInt(date[1]);
                var dateYear = parseInt(date[2]);
                var eventMonth = convertMonthWithID(dateMonth);
				specialEvent = post.special;
				console.log('SPECIAL: ', post.special);

                if (CALENDAR_DEBUG) {
                	console.log(eventMonth, currentMonth);
                }
                if (eventMonth === currentMonth) {
                    for (var j = 0; j < CALENDAR_CELL.length; j++) {
                        num = parseInt(CALENDAR_CELL[j].innerText);
                        if (num === dateDay) {
                            CALENDAR_CELL[j].innerHTML = '<div class="jsCalendar-dayWrapper">'+CALENDAR_CELL[j].innerHTML+'</div>' ;
													CALENDAR_CELL[j].classList.add("jsCalendar-selected", "no-barba-prefetch");

                            var theDate = dateYear+'/'+dateMonth+'/'+dateDay
                            var theDate = new Date(theDate)
                            var options = {year: 'numeric', month: 'long', day: 'numeric' };
                            var locale = 'fr-CA';
                            var ensavoirplus = 'En savoir plus';
                            var downloadlabel = 'Télécharger le programme';
                            if(getTheCurrentLang() == 'en') {
                                locale = 'en-US'
								downloadlabel = 'Download the program';
                            }

                            // prebuild the correct btn
                            console.log('---- POST ----');
                            var outButton;
                            if (CURRENT_CPT == 'programmes' && post.file) {
                            	outButton = '' +
                            		"<a class='Btn Icon-right no-barba' download target='_blank' data-icon='pdf' href='" +
                                    post.file.url +
                                    "'>" +
                                    downloadlabel  +
                                    "</a>"+
                            	'';
                            } else {
                            	outButton = ' ';
                            }

                            if ( (CURRENT_CPT == 'programmes' && post.file) ) {
								console.log('CURRENT_CPT: ', CURRENT_CPT);
                            	var isSpecial  = CURRENT_CPT == 'programmes' && specialEvent;
                            	var specialClass = 'jsCalendar-selected-special';
                            	var outClass = isSpecial ? specialClass : '';

                            	if (isSpecial) {
                            		CALENDAR_CELL[j].classList.add("jsCalendar-selected-special");
                            	}

                                var outputHtml=
                                    '<div class="jsCalendar-info-events '+outClass+' " data-id="' + post.imageId + '">' +
                                    "<button class='js-close'></button>"+
                                    "<img src='' class='jsCalendar-info-events-image' />" +
                                    "<div class='jsCalendar-info-events-wrapper'>"+
                                    "<div class='jsCalendar-info-events-title'>" +
                                    post.title +
                                    "</div><div class='jsCalendar-info-events-date'><span>" +
                                    theDate.toLocaleDateString(locale, options) + ' ' +  post.heure +
                                    "</span></div><div class='jsCalendar-info-events-desc'>" +
                                    post.description +
                                    "</div><div>" +
                                    outButton +
                                    "<span></span></div></div></div>";
                            } else {
								console.log('CURRENT_CPT: ', CURRENT_CPT);
								var outClass = '';
								if (!specialEvent) {
									outClass += 'jsCalendar-dayWrapper';
								} else {
									outClass += 'jsCalendar-selected-special';
								}

								CALENDAR_CELL[j].classList.add(outClass);

								var extraoutClass = '';
								if (!specialEvent) {
									extraoutClass += '';
								} else {
									extraoutClass += 'sCalendar-selected-special';
								}
								
                                var outputHtml =
                                    "<div class='"+extraoutClass+" jsCalendar-info-events' data-id='" +
                                    post.imageId +
                                    "'>" +
                                    "<button class='js-close'></button>"+
                                    "<img src='' class='jsCalendar-info-events-image' />" +
                                    "<div class='jsCalendar-info-events-wrapper'>"+
                                    "<div class='jsCalendar-info-events-title'>" +
                                    post.title +
                                    "</div><div class='jsCalendar-info-events-date'><span>" +
                                    theDate.toLocaleDateString(locale, options) + ' ' +  post.heure
                                    "</span></div><div class='jsCalendar-info-events-desc'>" +
                                    post.description +
                                    "</div><div>" +
                                    outButton +
                                    "<span></span></div></div></div>";
                            }
                            CALENDAR_CELL[j].insertAdjacentHTML("beforeend", outputHtml);
                            //if(screenWidth < 991) {
	                            initToggleDate(CALENDAR_CELL[j], theCalendar);
	                            CALENDAR_CELL[j].getElementsByClassName('js-close')[0].addEventListener('click', function(){
	                                toggleDate(this.parentElement, 'close', theCalendar);
	                            })
                            //}

                        }
                    }
                }
            }

			resolve();
		});

		var third = new Promise(function(resolve, reject) {
			for (var i = 0; i < POSTS_ARRAY.length; i++) {
				var post = POSTS_ARRAY[i];
				var imgPost = Calendar.prototype.imageFetch(post);
				imgPost.then(function(imgRes) {
					obj = imgRes;

					POST_IMAGES.push(obj);
				});
			}

			resolve();
		});

		var fourth = new Promise(function(resolve, reject) {

			var events = document.querySelectorAll(".jsCalendar-info-events");

			setTimeout(function() {
				for (var i = 0; i < events.length; i++) {
					var e = events[i];
					var id = e.dataset.id;

					var img = e.getElementsByTagName("img")[0];
					var url = Calendar.prototype.getImageByID(id);
					img.src = url;
				}
			}, 1000);

			
		});
		
		Promise.all([first, second, third, fourth]).then(function(values) {});

		formatMonth(theCalendar);
	}
};


function postsRequest_listener() {
	var posts = JSON.parse(this.responseText);

	buildPostObject(posts);
}

function postsRequest_listener_error() {
	console.error("Error fetching events");
}

function buildPostObject(posts) {

	if (CALENDAR_DEBUG) {
		console.log(posts);
	}

	for (var i = 0; i < posts.length; i++) {
		var post = posts[i];

		if (CALENDAR_DEBUG) {
			console.log(post.acf);
		}

		params = {
            date: post.acf.event_date,
            dates: post.acf.event_dates,
			description: post.acf.event_description,
			title: post.title.rendered,
			imageId: post.featured_media,
			link: post.link,
			special: post.acf.event_status,
			file: post.acf.event_file,
		};

		var Obj = new Calendar(params);
		POSTS_ARRAY.push(Obj);
	}

	Calendar.prototype.build();
}

function convertMonthWithID(id) {
	var months = [
		tr("janvier", "january"),
		tr("février", "february"),
		tr("mars", "march"),
		tr("avril", "april"),
		tr("mai", "may"),
		tr("juin", "june"),
		tr("juillet", "july"),
		tr("août", "august"),
		tr("septembre", "september"),
		tr("octobre", "october"),
		tr("novembre", "november"),
		tr("décembre", "december")
	];

	return months[id - 1];
}


function formatMonth(element) {
	if(!element) {
		return false;
	}
	var monthBlock = element.querySelector('.jsCalendar-title-name');
	var monthStr = monthBlock.innerHTML;
	monthStr = monthStr.split(' ');
	monthStr[1] = '<span>'+monthStr[1]+'</span>';
	monthStr = monthStr.join(' ');
	monthBlock.innerHTML = monthStr;
}

function initToggleDate(el, wrapper) {
	el.addEventListener('click', function() {
		if(this.classList.contains('is-active')) {
			toggleDate(this, 'hide', wrapper);
			return;
		}
		toggleDate(this, 'show', wrapper)
	});
}

function toggleDate(el, behavior, wrapper) {

	if(behavior == 'hide') {
		el.classList.remove('is-active');
		Scrollbar.getAll()[0].scrollIntoView(
			wrapper, {
				offsetTop: number = 150
			}
		);
		return;
	}

	if(behavior == 'show') {
		if(wrapper) {
			var tds = wrapper.getElementsByTagName('td');
			for (var i = 0; i < tds.length; i++) {
				tds[i].classList.remove('is-active');
			}
		}
		el.classList.add('is-active');
		Scrollbar.getAll()[0].scrollIntoView(
			el.getElementsByClassName('jsCalendar-info-events')[0], {
				offsetTop: number = 150
			}
		);
		return;	
	}

	el.classList.toggle('is-active');
	return;
}